export enum ScheduleType {
  Shift = "Shift",
  Availability = "Availability",
  Leave = "Leave"
}
